'use strict'

import { createBrowserHistory, createPath } from 'history';

let _history;

export const getHistory = () => _history;

export const historyManager = history => {

	_history = history;
	const _listeners = [];

	const triggerLocation = ctx => _listeners.forEach(listener => listener(ctx));

	return {
		addListener: fn => {
			_listeners.push(fn);
		},
		triggerLocation,
		listen: () => _history.listen(triggerLocation),
	};
};

/*const unsubscribeStore = store.subscribe(() => {

	const { location } = store.getState();

	const path = createPath(location);

	switch (location.action) {

		case 'POP':		return history.pop(location);
		case 'PUSH':	return history.push(location);
		case 'REPLACE':	return history.replace(location);
	}
});*/
